export default __webpack_public_path__ + "static/media/banana3.325b4312.svg";